// extracted by mini-css-extract-plugin
module.exports = {"mergeTagsPopUp":"communityMergeTags_mergeTagsPopUp__v_uiM","mergeTagContent":"communityMergeTags_mergeTagContent__c3OIL"};